import { useCallback, useEffect, useRef, useState } from 'react'
import HomePageMostRecent from './HomePageMostRecent'
import HomePagePromotionalProducts from './HomePagePromotionalProducts'
import HomePageRecentVisits from './HomePageRecentVisits'
import HomePageTopBrand from './HomePageTopBrand'
import HomePageTopFavorites from './HomePageTopFavorites'

import { KeyValuePair } from '../../base/models'
import { useAppSelector } from '../../redux/app/hooks'
import { selectedTheme } from '../../redux/slices/theme/themeSlice'
import HomePageCampaigns from './HomePageCampaigns'
import { IBestSellers, IBrandDetail, ICampaignsProducts, IProducts, IProductSuggestionAI } from './commonModels/models'
import './css/styles.scss'
import { GetBrandDetailApi } from './services/getBrandDetailApi'
import { GetCampaignsProductsApi } from './services/getCampaignsProductsApi'
// import data from '../../api/campaign.json'
import { css } from '@emotion/css'
import Swal from 'sweetalert2'
import { translate } from '../../base/localization'
import IPModal from '../../components/IPModal/IPModalContract'
import DealerContractModal from '../../components/DealerContract/DealerContractModal'
import { IDealerContractPopup } from './commonModels/dealerContractModels'
import IPRadio from '../../components/IPRadio'
import Translations from '../../translations'
import { GetCampaignsApi } from '../Campaings/services/getCampaignsApi'
import '../Register/components/SellerApplication.scss'
import HomePageBestSellers from './HomePageBestSellers'
import { ContractPopUp } from './services/contractpopupApi'
import { GetMostSelledProductsByCatagoriesApi } from './services/getMostSelledProductsByCatagoriesApi'
import HomePageMostOrder from './HomePageMostOrder'
import { TeminatPopupApi } from './services/teminatpopupApi'
import { ExcelAnnouncementPopupApi } from './services/excelAnnouncementPopupApi'
import HomePageSuggestion from './HomePageSuggestion'
import { GetAISuggestionApi } from './services/getAISuggestionApi'
import { GetProvizyonRequest, SapProvizyonGroupedResponseModel } from '../MySpecial/Reports/Provizyon/models'
import { formatDate } from '../../base/utils/dataHelper'
import { GetProvizyonApi } from '../MySpecial/Reports/Provizyon/services/getProvizyonApi'
import { GetPKPopupApi } from '../MySpecial/Reports/Provizyon/services/getPKPopupApi'
import { CompayPopupApi } from './services/compaypopupApi'
import { CompayPopupApprovalApi, IApproveComPayAgreementRequest } from './services/compaypopupApprovalApi'
import FeedbackReplyPopup from '../../components/FeedbackReplyPopup'
import {
  FeedbackRepliesPendingApi,
  FeedbackReplySeenApi,
  IFeedbackReply,
} from '../../components/FeedbackReplyPopup/feedbackReplyApi'
import { resolve } from 'path/posix'

// function HomePageCardLists(props) {
//   const [brand, setBrand] = useState<IBrandDetail>({
//     List: [],
//     Count: 0,
//   })
//   const theme = useAppSelector(selectedTheme)
//   useEffect(() => {
//     getBrands()
//     getCampaignsProducts(theme.id)
//     getCampaigns(theme.id)
//     getMostSelledProductsByCatagories()
//   }, [theme.id])

//   useEffect(() => {
//     IsContractPopup()
//   }, [])

//   const [popup, setPopup] = useState<boolean>(false)
// //   const [appModel, setAppModel] = useState<any>()
//   const [tel, setTel] = useState<string>('')
//   const [mail, setMail] = useState<string>('')

// //   const [onay, setOnay] = useState<number>(0)

//   const IsContractPopup = async () => {
//     const api = new ContractPopUp({})
//     api
//       .contractPopup()
//       .then((res: any) => {
//         if (res) {
//           setPopup(true)
//           setAppModel(res)
//         }
//       })
//       .catch((err: any) => {
//         console.log(err)
//       })
//   }

//   const sendContract = async (id: number) => {
//     if (onay && kvkk) {
//       const req: number[] = [id]
//       const api = new ContractApply({})
//       api
//         .contractApply(req)
//         .then((res: any) => {
//           if (res) {
//             Swal.fire({
//               icon: 'success',
//               title: 'Sözleşme tarafınıza gönderilmiştir.',
//               showConfirmButton: true,
//               allowOutsideClick: true,
//             })
//             setPopup(false)
//           }
//         })
//         .catch((err: any) => {
//           Swal.fire({
//             icon: 'error',
//             title: 'Hata! Lütfen daha sonra tekrar deneyin.',
//             showConfirmButton: true,
//             allowOutsideClick: true,
//           })
//         })
//     } else {
//       Swal.fire({
//         icon: 'error',
//         title: 'Devam etmeden önce KVKK metnini onaylamalı ve Ticari Elektronik İletilerini kabul etmelisiniz.',
//         showConfirmButton: true,
//         allowOutsideClick: true,
//       })
//     }
//   }

//   const getBrands = async () => {
//     const api = new GetBrandDetailApi({})
//     const queryParams: KeyValuePair<string> = new KeyValuePair<string>()
//     queryParams.add('IsHomePage', 'true')
//     api.queryParams = queryParams
//     api.getBrandList(6, theme.id).then((res: IBrandDetail) => {
//       setBrand(res)
//     })
//   }
//   const [campaignsProducts, setCampaignsProducts] = useState<any>({
//     Count: 0,
//     Products: [],
//   })

//   const [campaigns, setCampaigns] = useState<any>()
//   const [bestSellers, setBestSellers] = useState<IBestSellers[]>()

//   const t = translate(Translations)

//   const getCampaignsProducts = async (companyId: number) => {
//     const data: ICampaignsProducts = {
//       PageSize: 10000,
//       PageNumber: 0,
//       CampaignId: 0,
//       Company: companyId
//     }
//     const api: GetCampaignsProductsApi = new GetCampaignsProductsApi({})
//     api.getCampaignsProducts(data).then((res: any) => {
//       if (res)
//         return setCampaignsProducts(res)
//       setCampaignsProducts({
//         Count: 0,
//         Products: [],
//       })
//     }).catch((e) => {
//       setCampaignsProducts({
//         Count: 0,
//         Products: [],
//       })
//     })
//   }

//   const getCampaigns = async (companyId: number) => {
//     const data: ICampaignsProducts = {
//       PageSize: 10000,
//       PageNumber: 0,
//       CampaignId: 0,
//       Company: companyId,
//     }
//     const api: GetCampaignsApi = new GetCampaignsApi({})
//     api.getCampaigns(data).then((res: any) => {
//       setCampaigns(res)
//     })
//   }

//   const getMostSelledProductsByCatagories = async () => {
//     const api: GetMostSelledProductsByCatagoriesApi = new GetMostSelledProductsByCatagoriesApi({})
//     const queryParams: KeyValuePair<number> = new KeyValuePair<number>()
//     queryParams.add('dayBefore', 7)
//     queryParams.add('minSelledProductCount ', 0)
//     queryParams.add('minSelledProductQuantityCount', 5)
//     queryParams.add('company', theme.id)
//     api.queryParams = queryParams
//     api.getMostSelledProductsByCatagories().then((res: IBestSellers[]) => {
//       setBestSellers(res)
//     })
//   }

//   return (
//     <div className='container'>
//       {campaigns && campaigns.Count > 0 && <HomePageCampaigns data={campaigns.List} count={campaigns.Count} />}
//       {campaignsProducts && campaignsProducts.Count > 0 && (
//         <HomePagePromotionalProducts data={campaignsProducts.Products} count={campaignsProducts.Count} />
//       )}
//       {props.product && props.product.MostFavourites && props.product.MostFavourites.Count > 0 && (
//         <HomePageTopFavorites data={props.product.MostFavourites.Products} count={props.product.MostFavourites.Count} />
//       )}
//       {props.product && props.product.RecentVisits && props.product.RecentVisits.Count > 0 && (
//         <HomePageRecentVisits data={props.product.RecentVisits.Products} count={props.product.RecentVisits.Count} />
//       )}
//       {/* {
//         product &&
//         product.RecentVisits &&
//         product.RecentVisits.Count > 0 &&
//         <HomePageSimilarItems data={data["SimilarItems"]} />
//       } */}
//       {props.product && props.product.NewProducts && props.product.NewProducts.Count > 0 && (
//         <HomePageMostRecent data={props.product.NewProducts.Products} count={props.product.NewProducts.Count} />
//       )}
//       {bestSellers && bestSellers.length > 0 && <HomePageBestSellers data={bestSellers} />}
//       {brand && brand.Count > 0 && <HomePageTopBrand data={brand} />}
//       <IPModal
//         show={popup}
//         width={1000}
//         style={{ textAlignLast: 'center' }}
//         onClose={() => setPopup(false)}
//         onConfirm={() => {
//           sendContract(appModel.Id)
//         }}
//       >
//         <div className='sellerApplicationForm'>
//           <div
//             style={{
//               position: 'relative',
//               width: '100%',
//               maxWidth: '100%',
//             }}
//           >
//             <img
//               src='images/sozlesme_yenileme_.jpg'
//               alt=''
//               style={{
//                 width: '100%',
//                 height: 'auto',
//                 display: 'block',
//               }}
//             />
//             <div
//               style={{
//                 position: 'absolute',
//                 top: '63.5%', // Alt kenara göre ayarlayabilirsiniz
//                 left: '50%',
//                 transform: 'translateX(-50%)',
//                 textAlignLast: 'left',
//                 width: '100%',
//                 boxSizing: 'border-box',
//               }}
//             >
//               <p
//                 style={{
//                   marginTop: '0',
//                   display: 'block',
//                   fontWeight: 'bold',
//                   textAlignLast: 'left',
//                   paddingLeft: '45%',
//                   fontSize: '120%',
//                   color: 'white',
//                 }}
//               >
//                 {appModel && appModel.MobilePhone}
//               </p>
//               <p
//                 style={{
//                   margin: '0',
//                   display: 'block',
//                   fontWeight: 'bold',
//                   textAlignLast: 'left',
//                   paddingLeft: '45%',
//                   fontSize: '120%',
//                   color: 'white',
//                 }}
//               >
//                 {appModel && appModel.Email}
//               </p>
//             </div>
//           </div>
//           <div className='form-group col-md-12'>
//             <div className='infoWrapper'>
//               <div className='acceptForm'>
//                 {t('pages.register.bayiForms.electronicMessage')}
//                 <a style={{ color: 'red' }} className='infoMarker'>
//                   ?
//                 </a>
//                 <div className='infoBox'>
//                   {' '}
//                   ‘’ İNDEKS GRUP ŞİRKETLERİ ürün ve hizmetleri ile ilgili kampanyalar, tanıtımlar, duyurular hakkında
//                   link ve yönlendirmeleri, tanıtımları, haberleri veya reklamları da içerebilen şekilde E-BAYİ'yi
//                   bilgilendirmek için E-BAYİ'nin gerek sözleşmenin imzalanması sırasında gerekse sonradan bildirdiği
//                   telefon numaraları, faks, posta ve e-posta adreslerinden oluşan tüm bilgileri kullanabilir, yasal
//                   düzenleme kapsamında ticari iletişim ve ticari elektronik ileti gönderebilir. E-BAYİ, bu kapsamda
//                   bildirdiği telefon numaraları, faks, posta ve e-posta adresleri gibi iletişim bilgileri için izin
//                   vermeye yetkili olduğunu, verdiği iletişim bilgilerinin doğru ve gerçek olduğunu, kendisi ile ilişkisi
//                   olmayan 3. kişilere ait bilgileri sağlaması halinde doğabilecek tüm zarardan sorumlu olduğunu kabul,
//                   beyan ve taahhüt eder. ‘’
//                 </div>
//               </div>
//             </div>
//             <div className='d-flex gap-4' style={{ display: 'flex', justifyContent: 'space-around' }}>
//               <IPRadio
//                 text={t('pages.register.bayiForms.yes')}
//                 name='CommercialMessage'
//                 onClick={() => {
//                   setOnay(1)
//                 }}
//                 checked={onay === 1}
//               />
//               <IPRadio
//                 text={t('pages.register.bayiForms.no')}
//                 name='CommercialMessage'
//                 onClick={() => {
//                   setOnay(0)
//                 }}
//                 checked={onay === 0}
//               />
//             </div>
//           </div>
//           <div className='form-group col-md-12' style={{ display: 'flex', justifyContent: 'space-around' }}>
//             <div className='acceptForm'>
//               <div className='d-flex align-items-center'>
//                 <div>
//                   {t('pages.register.bayiForms.kvk')}{' '}
//                   <span
//                     className={css`
//                       color: #ec4c4c;
//                       cursor: pointer;
//                       &:hover {
//                         color: red;
//                       }
//                     `}
//                     onClick={() => setShowModal(true)}
//                   >
//                     {t('pages.register.bayiForms.click')}
//                   </span>
//                 </div>
//                 {kvkk ? '✅' : ''}
//               </div>
//             </div>
//           </div>
//         </div>
//       </IPModal>
//       <IPModal
//         title='KVKK Aydınlatma Metni'
//         width={1200}
//         show={showModal}
//         confirmText='Onayla'
//         onConfirm={() => {
//           setKvkk(true)
//           setShowModal(false)
//         }}
//         onClose={() => {
//           setShowModal(false)
//         }}
//         closeOnEscapeKey={true}
//         checkbox={
//           <div className='d-flex align-items-center'>
//             <IPCheckbox
//               name='KvkApproval'
//               onCheckedChange={(checked: boolean) => {
//                 setKvkk(true)
//               }}
//               checked={kvkk}
//             />
//             <div onClick={() => setKvkk(true)} className='ml-3 mb-2' style={{ cursor: 'pointer' }}>
//               KVKK metnini okudum ve onaylıyorum.
//             </div>
//           </div>
//         }
//       >
//         <>
//           {window.innerWidth < 1000 && (
//             <iframe
//               title='kvkk-aydinlatma-metni'
//               src='https://docs.google.com/gview?embedded=true&url=https://dev-b2b.vbt.com.tr:1443/assetWeb/docs/kvkk.pdf'
//               style={{ height: '90vh' }}
//             ></iframe>
//           )}
//           {window.innerWidth > 1000 && (
//             <iframe title='kvkk-aydinlatma-metni' src='/assetWeb/docs/kvkk.pdf' style={{ height: '90vh' }}></iframe>
//           )}
//         </>
//       </IPModal>
//     </div>
//   )
// }

//export default HomePageCardLists

function HomePageCardLists(props, IsVodafone) {
  const [brand, setBrand] = useState<IBrandDetail>({ List: [], Count: 0 })
  const theme = useAppSelector(selectedTheme)

  const [popup, setPopup] = useState<boolean>(false)
  const [appModel, setAppModel] = useState<IDealerContractPopup | null>(null)
  const [tel, setTel] = useState<string>('')
  const [mail, setMail] = useState<string>('')
  const [showCompayModal, setShowCompayModal] = useState<boolean>(false)
  const [compayData, setCompayData] = useState<any>(null)
  const [compayPdfUrl, setCompayPdfUrl] = useState<string | null>(null)
  // B-Gini geri bildirim dönüşleri (Faz-37): sırayla gösterilir; kuyruk bitince zincir devam eder.
  const [feedbackReplies, setFeedbackReplies] = useState<IFeedbackReply[]>([])
  const [feedbackReplyTotal, setFeedbackReplyTotal] = useState(0)
  const feedbackRepliesDoneRef = useRef<(() => void) | null>(null)

  const [campaignsProducts, setCampaignsProducts] = useState<any>({ Count: 0, Products: [] })
  const [campaigns, setCampaigns] = useState<any>(null)
  const [bestSellers, setBestSellers] = useState<IBestSellers[]>([])
  const [AISuggest, setAISuggest] = useState<IProductSuggestionAI>()
  const [provData, setProvData] = useState<SapProvizyonGroupedResponseModel[]>([])
  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  inititalStartDate.setMonth(8)
  inititalStartDate.setFullYear(2025)
  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState(new Date())
  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(' ', 'T')
  }


  const t = translate(Translations)

  const fetchBrands = useCallback(async () => {
    const api = new GetBrandDetailApi({})
    const queryParams = new KeyValuePair<string>()
    queryParams.add('IsHomePage', 'true')
    api.queryParams = queryParams
    const res = await api.getBrandList(6, theme.id)
    setBrand(res)
  }, [theme.id])

  const fetchCampaignsProducts = useCallback(async (companyId: number) => {
    setCampaignsProducts({ Count: 0, Products: [] })
    const data: ICampaignsProducts = {
      PageSize: 10000,
      PageNumber: 0,
      CampaignId: 0,
      Company: companyId,
    }
    const api = new GetCampaignsProductsApi({})
    try {
      const res = await api.getCampaignsProducts(data)
      setCampaignsProducts(res)
    } catch {
      setCampaignsProducts({ Count: 0, Products: [] })
    }
  }, [])

  const fetchAISuggestion = useCallback(async (companyId: number) => {
    const newData: IProductSuggestionAI = {
      Products: [], Count: 0,
      ProductsCount: 0
    }
    setAISuggest(newData)

    const api = new GetAISuggestionApi({})
    const queryParams = new KeyValuePair<number>()
    queryParams.add('companyId', companyId)
    api.queryParams = queryParams
    try {
      const res = await api.getSuggest()
      setAISuggest(res)
    } catch {
      const newData: IProductSuggestionAI = {
        Products: [], Count: 0,
        ProductsCount: 0
      }
      setAISuggest(newData)
    }
  }, [])

  const fetchCampaigns = useCallback(async (companyId: number) => {
    setCampaigns(undefined)
    const data: ICampaignsProducts = {
      PageSize: 10000,
      PageNumber: 0,
      CampaignId: 0,
      Company: companyId,
    }
    const api = new GetCampaignsApi({})
    const res = await api.getCampaigns(data)
    setCampaigns(res)
  }, [])

  const fetchBestSellers = useCallback(async () => {
    setBestSellers([])
    const api = new GetMostSelledProductsByCatagoriesApi({})
    const queryParams = new KeyValuePair<number>()
    queryParams.add('dayBefore', 7)
    queryParams.add('minSelledProductCount', 0)
    queryParams.add('minSelledProductQuantityCount', 5)
    queryParams.add('company', theme.id)
    api.queryParams = queryParams
    const res = await api.getMostSelledProductsByCatagories()
    setBestSellers(res)
  }, [theme.id])

  const isContractPopup = useCallback(async () => {
    const api = new ContractPopUp({})
    try {
      const res = await api.contractPopup()
      if (res) {
        setPopup(true)
        setAppModel(res)
      }
    } catch (err) {
      console.log(err)
    }
  }, [])

  const isCompayPopup = useCallback(async () => {
    return new Promise<void>(async (resolve) => {
      const api: any = new CompayPopupApi({})
      try {
        const res: any = await api.creditContractPopup()
        console.log(res)
        if (res) {
          setCompayData(res)
          if (res.FileUrl) {
            setCompayPdfUrl(res.FileUrl)
          }
          setShowCompayModal(true)
        }
        resolve()
      } catch (err) {
        console.log(err)
        resolve()
      }
    })
  }, [])

  const isPKPopup = useCallback(async () => {
    return new Promise<void>((resolve) => {
      const getPK: GetPKPopupApi = new GetPKPopupApi({})
      getPK
        .getPK()
        .then(result => {
          if (result) {
            if (result?.length > 0) {
              Swal.fire({
                icon: 'warning',
                title: 'PK Bilgilendirme',
                html: result,
                showConfirmButton: true,
                allowOutsideClick: true,
                width: '1200px',
              }).then(() => {
                resolve()
              })
            } else {
              resolve()
            }
          } else {
            console.warn('PK result is empty.')
            resolve()
          }
        })
        .catch((err: any) => {
          if (!err.description || err.description === 'OK') {
          } else {
          }
          resolve()
        })
    })
  }, [])

  const isPOPopup = useCallback(async () => {
    return new Promise<void>((resolve) => {
      const req: GetProvizyonRequest = {
        Baslangic: formatDate(startDate),
        Bitis: formatDate(endDate),
        Type: "B"
      }
      const getProvizyon: GetProvizyonApi = new GetProvizyonApi({})
      getProvizyon
        .getProvizyon(req)
        .then(result => {
          if (result) {
            if (result?.length > 0) {
              Swal.fire({
                icon: 'warning',
                title: 'Provizyon Bilgilendirme',
                html: `
        <a href="/myspecial/reports/provizyon"  style="text-decoration: underline;">
          Fatura bekleyen açık provizyonunuz bulunmaktadır.
        </a>
        İlgili provizyon için fatura kestiyseniz bu mesajı dikkate almayınız.
      `,
                showConfirmButton: true,
                allowOutsideClick: true,
                width: '900px',
              }).then(() => {
                resolve()
              })
            } else {
              resolve()
            }
          } else {
            console.warn('Provizyon result is empty.')
            resolve()
          }
        })
        .catch((err: any) => {
          if (!err.description || err.description === 'OK') {
          } else {
          }
          resolve()
        })
    })
  }, [startDate, endDate])

  const isTeminatPopup = useCallback(async () => {
    return new Promise<void>((resolve) => {
      const api = new TeminatPopupApi({})
      api.teminatPopup()
        .then(res => {
          if (res) {
            Swal.fire({
              icon: 'warning',
              title: 'Teminat Mektubu Bilgilendirme',
              html: res,
              showConfirmButton: true,
              allowOutsideClick: true,
              width: '700px',
            }).then(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
        .catch(err => {
          console.log(err)
          resolve()
        })
    })
  }, [])

  /**
   * Excel ile yuklenen bayi bazli duyuru. Metin sunucuda uretilip donduruldugu icin
   * burada yalniz gosterilir. Excel'den gelen metin HTML olarak yorumlanmasin diye
   * kacisi yapilir; satir sonlari <br> olur.
   */
  const isExcelAnnouncementPopup = useCallback(async () => {
    const escapeHtml = (value: string) =>
      (value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/\n/g, '<br/>')

    return new Promise<void>(resolve => {
      const api = new ExcelAnnouncementPopupApi({})
      api
        .getPopup()
        .then(async res => {
          if (!res || !res.Items || res.Items.length === 0) {
            resolve()
            return
          }

          const image = res.ImageUrl
            ? `<div class="text-center mb-2"><img src="${res.ImageUrl}" alt="" style="max-width:100%" /></div>`
            : ''

          // Teminat duyurusu işaretliyse mektuplar popup'ın ALTINDA listelenir. Liste boş
          // gelirse (mektup yok ya da SAP okunamadı) bölüm hiç çizilmez.
          const guaranteeTable = () => {
            const letters = res.GuaranteeLetters ?? []
            if (letters.length === 0) return ''

            const money = (value: number) =>
              (value ?? 0)
                .toFixed(2)
                .replace('.', ',')
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.')

            const day = (value: string) => new Date(value).toLocaleDateString()

            // Renk sunucunun verdiği Status'ten gelir; kural tek yerde (GuaranteeLetterStatus).
            const color = (status: number) => (status === 2 ? '#dc3545' : status === 1 ? '#fd7e14' : '#198754')

            // Yalnız sayı ve tarih kolonları nowrap; banka ve vergi dairesi uzun olduğu
            // için sarabilsin, tablo popup'ı gereksiz genişletmesin.
            const cell = 'padding:4px 8px;border:1px solid #dee2e6;vertical-align:top'
            const nowrapCell = `${cell};white-space:nowrap`
            const head = `${nowrapCell};background:#e0e0e2;font-weight:600`

            const rows = letters
              .map(
                letter => `<tr style="color:${color(letter.Status)}">
                    <td style="${nowrapCell}">${escapeHtml(letter.No)}</td>
                    <td style="${nowrapCell}">${day(letter.StartDate)}</td>
                    <td style="${nowrapCell}">${day(letter.EndDate)}</td>
                    <td style="${cell}">${escapeHtml(letter.Bank)}</td>
                    <td style="${cell}">${escapeHtml(letter.TaxLocation)}</td>
                    <td style="${nowrapCell};text-align:right">${money(letter.Amount)}</td>
                  </tr>`
              )
              .join('')

            return `<div style="margin-top:18px;text-align:left">
                <div style="font-weight:600;margin-bottom:6px">Teminat Mektuplarınız</div>
                <div style="overflow-x:auto">
                  <table style="width:100%;border-collapse:collapse;font-size:13px">
                    <thead>
                      <tr>
                        <th style="${head}">No</th>
                        <th style="${head}">Başlangıç</th>
                        <th style="${head}">Bitiş</th>
                        <th style="${head}">Banka</th>
                        <th style="${head}">Vergi Dairesi</th>
                        <th style="${head};text-align:right">Teminat</th>
                      </tr>
                    </thead>
                    <tbody>${rows}</tbody>
                    <tfoot>
                      <tr>
                        <td style="${head}" colspan="5">Toplam</td>
                        <td style="${head};text-align:right">${money(res.GuaranteeTotal ?? 0)}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div style="margin-top:6px;font-size:12px">
                  <span style="color:#dc3545">Kırmızı</span> vadesi geçmiş,
                  <span style="color:#fd7e14">turuncu</span> 30 gün içinde bitecek mektupları gösterir.
                </div>
              </div>`
          }

          // Teminat tablosu altı kolon; 700px'e sığmıyordu. Tablo varken popup genişliyor,
          // dar ekranda da taşmasın diye ekranın %96'sıyla sınırlanıyor.
          const popupWidth = (res.GuaranteeLetters?.length ?? 0) > 0 ? 'min(1100px, 96vw)' : '700px'

          const body = (text: string) => {
            const description = `<div style="text-align:left">${escapeHtml(text)}</div>`
            const content = res.ImagePosition === 2 ? `${description}${image}` : `${image}${description}`
            return `${content}${guaranteeTable()}`
          }

          // GroupMode 2 (Combined): tek pencerede alt alta. 1 (Separate): sirayla.
          if (res.GroupMode === 2) {
            await Swal.fire({
              title: res.Items[0].Topic,
              html: body(res.Items.map(item => item.Description).join('\n\n')),
              showConfirmButton: true,
              allowOutsideClick: true,
              width: popupWidth,
            })
          } else {
            for (const item of res.Items) {
              await Swal.fire({
                title: item.Topic,
                html: body(item.Description),
                showConfirmButton: true,
                allowOutsideClick: true,
                width: popupWidth,
              })
            }
          }

          // Gosterim kaydi popup kapandiktan sonra yazilir; yazilamazsa duyuru
          // bir sonraki ziyarette tekrar cikar - sessizce kaybolmaz.
          try {
            await api.markSeen(res.Id)
          } catch {
            // yoksayilir
          }

          resolve()
        })
        .catch(() => resolve())
    })
  }, [])

  /**
   * Admin'in olumsuz B-Gini geri bildirimine dönüşü (Faz-37 §3). Bayi/kullanıcı oturumdan çözülür; en fazla
   * 5 dönüş eskiden yeniye SIRAYLA gösterilir. Hata olursa popup gösterilmez (sessiz), zincir devam eder.
   */
  const isFeedbackReplyPopup = useCallback(async () => {
    return new Promise<void>(resolve => {
      new FeedbackRepliesPendingApi()
        .list()
        .then(replies => {
          if (replies.length === 0) {
            resolve()
            return
          }
          // Son dönüş kapatılınca zincir devam eder (closeFeedbackReply).
          feedbackRepliesDoneRef.current = resolve
          setFeedbackReplyTotal(replies.length)
          setFeedbackReplies(replies)
        })
        .catch(() => resolve())
    })
  }, [])

  /** "Tamam" ya da X: görüldü kaydı yazılır (yazılamazsa sonraki girişte tekrar çıkar), sıradakine geçilir. */
  const closeFeedbackReply = () => {
    const [current, ...rest] = feedbackReplies
    if (current) {
      new FeedbackReplySeenApi(current.ReplyId).markSeen().catch(() => undefined)
    }
    setFeedbackReplies(rest)
    if (rest.length === 0) {
      const done = feedbackRepliesDoneRef.current
      feedbackRepliesDoneRef.current = null
      done?.()
    }
  }

  useEffect(() => {
    fetchBrands()
    fetchCampaignsProducts(theme.id)
    fetchCampaigns(theme.id)
    fetchAISuggestion(theme.id)
    fetchBestSellers()
  }, [theme.id, fetchBrands, fetchCampaignsProducts, fetchCampaigns, fetchBestSellers, fetchAISuggestion])

  const [popupQueue, setPopupQueue] = useState<string[]>([])
  const [currentPopupIndex, setCurrentPopupIndex] = useState(0)
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  // Sıradaki popupu işle
  const processNextPopup = useCallback(async (index: number, queue: string[]) => {
    if (index >= queue.length) {
      setCurrentPopupIndex(-1)
      return
    }

    setCurrentPopupIndex(index)

    const popupType = queue[index]

    try {
      switch (popupType) {
        case 'contract':
          await isContractPopup()
          setIsPopupOpen(true)
          break
        case 'compay':
          await isCompayPopup()
          setIsPopupOpen(true)
          // Modal kapanması watcher tarafından algılanacak
          break
        case 'po':
          await isPOPopup()
          setIsPopupOpen(false)
          setTimeout(() => processNextPopup(index + 1, queue), 300)
          break
        case 'pk':
          await isPKPopup()
          setIsPopupOpen(false)
          setTimeout(() => processNextPopup(index + 1, queue), 300)
          break
        case 'teminat':
          await isTeminatPopup()
          setIsPopupOpen(false)
          setTimeout(() => processNextPopup(index + 1, queue), 300)
          break
        case 'excelAnnouncement':
          await isExcelAnnouncementPopup()
          setIsPopupOpen(false)
          setTimeout(() => processNextPopup(index + 1, queue), 300)
          break
        case 'feedbackReply':
          await isFeedbackReplyPopup()
          setIsPopupOpen(false)
          setTimeout(() => processNextPopup(index + 1, queue), 300)
          break
      }
    } catch (err) {
      console.log('Popup hatası:', err)
      setIsPopupOpen(false)
      setTimeout(() => processNextPopup(index + 1, queue), 300)
    }
  }, [
    isContractPopup,
    isCompayPopup,
    isPOPopup,
    isPKPopup,
    isTeminatPopup,
    isExcelAnnouncementPopup,
    isFeedbackReplyPopup,
  ])

  // Popupları başlat
  useEffect(() => {
    const initializePopups = async () => {
      const queue = ['contract']
      if (IsVodafone) {
        queue.push('po', 'pk', 'teminat')
      }
      queue.push('compay')
      queue.push('excelAnnouncement')
      // B-Gini geri bildirim dönüşü Excel duyurusundan SONRA (Faz-37 §3).
      queue.push('feedbackReply')
      setPopupQueue(queue)
      await processNextPopup(0, queue)
    }

    initializePopups()
  }, [processNextPopup])

  // Popup kapandığında sonraki popupu başlat
  useEffect(() => {
    if (!popup && isPopupOpen && currentPopupIndex === 0) {
      // Contract popup kapalı, sonraki popup'a geç
      const timer = setTimeout(() => {
        setIsPopupOpen(false)
        processNextPopup(currentPopupIndex + 1, popupQueue)
      }, 500)
      return () => clearTimeout(timer)
    }
  }, [popup, isPopupOpen, currentPopupIndex, popupQueue, processNextPopup])

  // Compay modal kapandığında sonraki popupu başlat
  useEffect(() => {
    if (!showCompayModal && isPopupOpen && currentPopupIndex >= 0 && popupQueue[currentPopupIndex] === 'compay') {
      // Blob URL'yi temizle
      if (compayPdfUrl) {
        URL.revokeObjectURL(compayPdfUrl)
        setCompayPdfUrl(null)
      }
      const timer = setTimeout(() => {
        setIsPopupOpen(false)
        processNextPopup(currentPopupIndex + 1, popupQueue)
      }, 300)
      return () => clearTimeout(timer)
    }
  }, [showCompayModal, isPopupOpen, currentPopupIndex, popupQueue, processNextPopup, compayPdfUrl])


  const handleCompayApproval = async () => {
    try {
      const api = new CompayPopupApprovalApi({})
      const request: IApproveComPayAgreementRequest = {
        FileUrl: compayPdfUrl || '',
      }
      await api.creditContractApproval(request)
      Swal.fire({
        icon: 'success',
        title: 'Sözleşme onaylanmıştır.',
        showConfirmButton: true,
        allowOutsideClick: true,
      })
      setShowCompayModal(false)
    } catch (err) {
      console.log(err)
      Swal.fire({
        icon: 'error',
        title: 'Hata! Lütfen daha sonra tekrar deneyin.',
        showConfirmButton: true,
        allowOutsideClick: true,
      })
    }
  }

  return (
    <div className='container'>
      {campaigns && campaigns.Count > 0 && <HomePageCampaigns data={campaigns.List} count={campaigns.Count} />}
      {campaignsProducts && campaignsProducts.Count > 0 && (
        <HomePagePromotionalProducts data={campaignsProducts.Products} count={campaignsProducts.Count} />
      )}
      {AISuggest && AISuggest?.Products?.length > 0 && <HomePageSuggestion data={AISuggest.Products} count={AISuggest?.ProductsCount ?? 0} />}
      {props.product && props.product.MostOrdered && props.product.MostOrdered.Count > 0 && (
        <HomePageMostOrder data={props.product.MostOrdered.Products} count={props.product.MostOrdered.Count} />
      )}
      {props.product && props.product.MostFavourites && props.product.MostFavourites.Count > 0 && (
        <HomePageTopFavorites data={props.product.MostFavourites.Products} count={props.product.MostFavourites.Count} />
      )}
      {props.product && props.product.RecentVisits && props.product.RecentVisits.Count > 0 && (
        <HomePageRecentVisits data={props.product.RecentVisits.Products} count={props.product.RecentVisits.Count} />
      )}
      {/* {
        product &&
        product.RecentVisits &&
        product.RecentVisits.Count > 0 &&
        <HomePageSimilarItems data={data["SimilarItems"]} />
      } */}
      {props.product && props.product.NewProducts && props.product.NewProducts.Count > 0 && (
        <HomePageMostRecent data={props.product.NewProducts.Products} count={props.product.NewProducts.Count} />
      )}
      {bestSellers && bestSellers.length > 0 && <HomePageBestSellers data={bestSellers} />}
      {brand && brand.Count > 0 && <HomePageTopBrand data={brand} />}
      {feedbackReplies.length > 0 && (
        <FeedbackReplyPopup
          key={feedbackReplies[0].ReplyId}
          title={feedbackReplies[0].Title}
          html={feedbackReplies[0].Html}
          position={{ index: feedbackReplyTotal - feedbackReplies.length, total: feedbackReplyTotal }}
          onClose={closeFeedbackReply}
        />
      )}
      {popup && (
        <DealerContractModal
          data={appModel}
          // Remote oturumda (bir bayiye baglanan MT/rapor kullanicisi) modal atlanabilir.
          allowSkip={props.isRemote === true}
          onCompleted={() => {
            setPopup(false)
            setAppModel(null)
          }}
        />
      )}
      <IPModal
        title='Alışveriş Kredisi Sözleşmesi'
        width={1200}
        show={showCompayModal}
        confirmText='Onayla'
        onConfirm={() => {
          handleCompayApproval()
        }}
        onClose={() => {
          setShowCompayModal(false)
        }}
        closeOnEscapeKey={true}
      >
        {compayData && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{ marginBottom: '20px' }}>
              <p style={{ fontWeight: 'bold', fontSize: '16px' }}>
                <strong>Bayi Adı:</strong> {compayData.DealerName}
              </p>
              <p style={{ fontWeight: 'bold', fontSize: '16px' }}>
                <strong>SAP Kodu:</strong> {compayData.DealerSapCode}
              </p>
              <p style={{ fontWeight: 'bold', fontSize: '16px' }}>
                <strong>Sözleşme Tarihi:</strong> {new Date(compayData.AgreementDate).toLocaleString('tr-TR')}
              </p>
            </div>

            {compayPdfUrl && (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <div style={{ marginBottom: '15px' }}>
                  <a
                    href={compayPdfUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ textDecoration: 'underline', cursor: 'pointer', color: '#0066cc' }}
                  >
                    PDF&apos;i yeni sekmede aç
                  </a>
                </div>

                <div style={{ width: '100%', height: '600px' }}>
                  <iframe
                    src={compayPdfUrl}
                    title='Compay Sözleşmesi'
                    style={{
                      width: '100%',
                      height: '100%',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                    }}
                  />
                </div>
              </div>
            )}

            {!compayPdfUrl && (
              <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <p style={{ color: '#666' }}>PDF yükleniyor...</p>
              </div>
            )}
          </div>
        )}
      </IPModal>
    </div>
  )
}

export default HomePageCardLists
